
import {Component, Vue} from "vue-property-decorator";
import Pagination from "@/components/Pagination/index.vue";
import ProductItem from "@/views/invoiceBookingOrder/component/ProductItem.vue";
import {
  pageInvoiceBookingOrder,
  pageInvoiceBookingOrderNative,
  queryDataSourceMode, updateDataSourceMode,
  updateInvoiceBookingOrderRemark
} from "@/api/invoice/index";
import {getUserByRole} from "@/api/users";
import {deepClone} from "@/utils/deepClone";
import {exportJson2Excel} from "@/utils/excel";
import {formatJson} from "@/utils";
import InvoiceAmountDetail from "@/views/invoiceBookingOrder/component/InvoiceAmountDetail.vue";
import Template from "@/views/system-management/template/index.vue";
import InvoiceDesc from "@/views/invoiceBookingOrder/component/InvoiceDesc.vue";
import {noTaxRefund, revertTaxRefund, taxRefund} from "@/api/booking-order";


@Component({
  name: "invoiceBookingOrder",
  components: {
    InvoiceDesc,
    Template,
    InvoiceAmountDetail,
    ProductItem,
    Pagination,
  },
})
export default class extends Vue {
  private dataMode = "";
  private showRemark = false;
  private current: any = {}
  private showCompleteTaxRefund = false;
  private taxRefundCode = "";
  private searchForm = [
    {
      label: "报关合同号",
      prop: "code",
      key: "code",
      type: "input",
      placeholder: "请选择报关合同号",
    },
    {
      label: "销售员/助理",
      prop: "seller",
      key: "seller",
      type: "select",
      clearable: true,
      options: [],
      value: "",
      placeholder: "请选择销售员/助理",
    },
    {
      label: "开票进度",
      prop: "invoiceProgress",
      key: "invoiceProgress",
      type: "select",
      clearable: true,
      options: [
        {name: "部分开票", value: "部分开票"},
        {name: "全部开票", value: "全部开票"},
      ],
      resetKey: {label: "name", value: "value"},
      value: "",
      placeholder: "全部",
    },
    {
      label: "核销进度",
      prop: "writeOffProgress",
      key: "writeOffProgress",
      type: "select",
      clearable: true,
      options: [
        {name: "部分核销", value: "部分核销"},
        {name: "全部核销", value: "全部核销"},
      ],
      resetKey: {label: "name", value: "value"},
      value: "",
      placeholder: "全部",
    },
    {
      label: "处理阶段",
      prop: "taxRefundStatus",
      key: "taxRefundStatus",
      type: "select",
      clearable: true,
      options: [
        {name: "PENDING", desc: "待退税"},
        {name: "COMPLETED", desc: "完成退税"},
        {name: "NO", desc: "不退税"},
      ],
      resetKey: {label: "desc", value: "name"},
      value: "PENDING",
      placeholder: "全部",
    },
    {
      label: "预录单核对时间",
      prop: "time",
      key: "time",
      type: "datePicker",
      valueFormat: "yyyy-MM-dd",
      value: "",
    },
  ];
  private loading = true;
  private tableCol = [
    {
      label: "报关合同号",
      prop: "bookingOrderCode",
      key: "bookingOrderCode",
      type: "link",
      width: 200,
    },
    {
      label: "销售人员",
      prop: "sellerName",
      key: "sellerName",
      render: (prop, row) => {
        if (row.selleAssistantName) {
          return `${row.sellerName}/${row.selleAssistantName}`;
        }
        return row.sellerName;
      }
    },
    {
      label: "预录单核对时间",
      prop: "checkPrerecordListDate",
      key: "checkPrerecordListDate",
    },
    {
      label: "开票进度",
      prop: "invoiceProgress",
      key: "invoiceProgress",
    },
    {
      label: "核销进度",
      prop: "writeOffProgress",
      key: "writeOffProgress",
    },
    {
      label: "开票总金额",
      prop: "invoiceTotalAmount",
      key: "invoiceTotalAmount",
      type: "link",
      click: 'handleTotalAmountClick'
    },
    {
      label: "已开票金额",
      prop: "invoiceAmount",
      key: "invoiceAmount",
      type: "custom",
      slot: "invoiceAmount0"
    },
    {
      label: "未开票金额",
      prop: "unInvoiceAmount",
      key: "unInvoiceAmount",
    },
    {
      label: "付款单分配金额",
      prop: "paymentDistributeAmount",
      key: "paymentDistributeAmount",
    },
    {
      label: "报关金额",
      prop: "bookingOrderAmount",
      key: "bookingOrderAmount",
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        {
          name: "产品明细",
          code: "",
          click: "handleProductItem",
        },
        {
          name: "发票管理",
          code: "",
          click: "handleInvoice",
        },
      ],
      width: 200,
    },
    {
      label: "备注",
      prop: "remark",
      key: "remark",
      type: "remark",
      length: 255,
    },
  ]
  public tableCol2 = [
    {
      label: "报关合同号",
      prop: "bookingOrderCode",
      key: "bookingOrderCode",
      type: "link",
      width: 200,
    },
    {
      label: "销售人员",
      prop: "sellerName",
      key: "sellerName",
      render: (prop, row) => {
        if (row.selleAssistantName) {
          return `${row.sellerName}/${row.selleAssistantName}`;
        }
        return row.sellerName;
      }
    },
    {
      label: "预录单核对时间",
      prop: "checkPrerecordListDate",
      key: "checkPrerecordListDate",
    },
    {
      label: "开票进度",
      prop: "invoiceProgress",
      key: "invoiceProgress",
    },
    {
      label: "核销进度",
      prop: "writeOffProgress",
      key: "writeOffProgress",
    },
    {
      label: "开票总金额",
      prop: "invoiceTotalAmount",
      key: "invoiceTotalAmount",
      type: "link",
      click: 'handleTotalAmountClick'
    },
    {
      label: "已开票金额",
      prop: "invoiceAmount",
      key: "invoiceAmount",
      type: "custom",
      slot: "invoiceAmount0"
    },
    {
      label: "未开票金额",
      prop: "unInvoiceAmount",
      key: "unInvoiceAmount",
    },
    {
      label: "付款单分配金额",
      prop: "paymentDistributeAmount",
      key: "paymentDistributeAmount",
    },
    {
      label: "报关金额",
      prop: "bookingOrderAmount",
      key: "bookingOrderAmount",
    },
    {
      label: "处理阶段",
      prop: "progressStage",
      key: "progressStage",
    },
    {
      label: "退税",
      prop: "",
      key: "",
      width: "140",
      type: "actions",
      options: [
        {
          name: "完成退税",
          code: "",
          key: "progressStage",
          value: "待退税",
          click: "handleCompleteTaxRefund"
        },
        {
          name: "不退税",
          code: "",
          key: "progressStage",
          value: "待退税",
          click: "handleNoTaxRefund"
        },
        {
          name: "",
          prop: "taxRefundCode",
          code: "",
          key: "progressStage",
          value: "完成退税",
          click: "handleCancelTaxRefund"
        },
        {
          name: "取消不退税(经理)",
          code: "",
          key: "progressStage",
          value: "不退税",
          click: "handleCancelNoTaxRefund"
        },
      ],
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        {
          name: "产品明细",
          code: "",
          click: "handleProductItem",
        },
        {
          name: "发票管理",
          code: "",
          click: "handleInvoice",
        },
      ],
      width: 200,
    },
    {
      label: "备注",
      prop: "remark",
      key: "remark",
      type: "remark",
      length: 255,
    },
  ]
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any[],
  };
  private selection = []
  private queryForm = {
    code: "",
    time: null,
    seller: "",
    invoiceProgress: "",
    writeOffProgress: "",
    startDate: null,
    endDate: null,
    taxRefundStatus: "PENDING",
  }


  async created() {
    await this.getDataMode()
    await this.getList()
    this.getUserList()
  }

  private async getDataMode() {
    const res = await queryDataSourceMode() as any;
    this.dataMode = res.name;
  }

  public getUserList() {
    getUserByRole('销售员,销售助理')
        .then((data) => {
          this.searchForm[1].options = data;
        })
  }

  private async updateDataSourceMode() {
    const params = {
      value: this.dataMode === "ACTUAL"? "NATIVE" : "ACTUAL"
    }
    await updateDataSourceMode(params);
    await this.getDataMode();
    await this.getList()
  }

  public querySearch(data) {
    this.table.pageNumber = 1;
    this.queryForm = data && data !== "reset" ? data : {};
    if (this.queryForm.time) {
      this.queryForm.startDate = this.queryForm.time[0];
      this.queryForm.endDate = this.queryForm.time[1];
    }
    delete this.queryForm.time
    this.getList();
  }

  private handleCompleteTaxRefund(row) {
    this.current = row;
    this.showCompleteTaxRefund = true;
  }

  private async completeTaxRefund() {
    await taxRefund(this.current.id, {taxRefundBatchNumber: this.taxRefundCode})
    this.$notify({
      title: "提示",
      message: "完成退税成功！",
      type: "success",
      duration: 2000,
    });
    this.taxRefundCode = "";
    this.showCompleteTaxRefund = false;
    await this.getList()
  }

  private handleNoTaxRefund(row) {
    this.$confirm(`确定不对【${row.bookingOrderCode}】进行退税吗?`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      noTaxRefund(row.id).then(() => {
        this.$message({
          type: 'success',
          message: `${row.bookingOrderCode}不退税成功`
        });
        this.getList();
      })
    })
  }

  private handleCancelTaxRefund(row, string) {
    this.$confirm(`确定要取消【${row.bookingOrderCode}】的${string}吗?`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      revertTaxRefund(row.id).then(() => {
        this.$message({
          type: 'success',
          message: `取消${row.bookingOrderCode}${string}成功`
        });
        this.getList();
      })
    })
  }

  private closeCompleteTaxRefund() {
    this.taxRefundCode = "";
    this.showCompleteTaxRefund = false;
  }

  public handleSelectionChange(val) {
    this.selection = val;
  }

  public handleProductItem(row) {
    (this.$refs['productItemRef'] as ProductItem)
        .openDialog(row)
  }

  public handleInvoiceAmount(row, prop) {
    (this.$refs['invoiceDescRef'] as InvoiceDesc)
        .openDialog({code: row.bookingOrderCode, type: "DECLARATION_INVOICE"})
  }

  public handleInvoice(row) {
    this.$router.push({
      name: "invoice",
      query: {
        bookingOrderId: row.bookingOrderId,
        bookingOrderCode: row.bookingOrderCode
      }
    })
  }

  public linkClick(row) {
    this.$router.push({
      name: "invoiceBookingOrderDetail",
      params: {
        id: row.id
      },
      query: {
        bookingOrderCode: row.bookingOrderCode,
        company: row.company,
      }
    })
  }

  public handleTotalAmountClick(row) {
    (this.$refs.invoiceAmountDetailRef as InvoiceAmountDetail).openDialog(
        {id: row.id, type: "DECLARATION_INVOICE"}
    )
  }

  public async handleRemark() {
    await updateInvoiceBookingOrderRemark(this.current.id, this.current.remark);
    this.$notify({
      title: "提示",
      message: "修改备注成功！",
      type: "success",
      duration: 2000,
    });
    this.showRemark = false;
    this.getList()
  }

  public handleDownload() {
    let list: any[];
    if (this.selection.length !== 0) {
      list = deepClone(this.selection);
    } else {
      list = deepClone(this.table.list);
    }
    const headers = this.tableCol.filter(v => v.label != '操作').map((v) => v.label);
    const fieldNames = this.tableCol.filter(v => v.label != '操作').map((v) => v.key);
    exportJson2Excel(
        headers,
        formatJson(fieldNames, list),
        `报关开票管理-${new Date()}`
    );
  }

  public async getList() {
    this.loading = true
    if (this.dataMode === 'NATIVE') {
      const params = {
        ...this.queryForm,
        pageNumber: this.table.pageNumber,
        pageSize: this.table.pageSize,
      }
      await pageInvoiceBookingOrderNative(params)
          .then((res) => {
                this.table.total = Number(res.total);
                this.table.list = res.content;
              }
          )
          .finally(() => this.loading = false)
    } else {
      const params = {
        ...this.queryForm,
        pageNumber: this.table.pageNumber,
        pageSize: this.table.pageSize,
      }
      await pageInvoiceBookingOrder(params)
          .then((res) => {
                this.table.total = Number(res.total);
                this.table.list = res.content;
              }
          )
          .finally(() => this.loading = false)
    }
  }

  private disableTaxRefund(row) {
    return row.invoiceProgress.split("/")[0] !== row.invoiceProgress.split("/")[1];
  }
}
